import KlaroCookies from './KlaroCookies';

export default KlaroCookies;
